import { StyleSheet, Platform } from 'react-native';

export default StyleSheet.create({
  containerStyle: theme => ({
    paddingVertical: 24,
    marginVertical: 10,
    borderTopWidth: 1,
    borderColor: theme.colors.VFDivider.tertiary,
    backgroundColor: theme.colors.cardBackgroundColor,
    height: Platform.OS === 'ios' ? 500 : 400,
  }),
});
